import { useCallback, useState } from 'react';
import { LogMessageLevel } from '../../types/gcs/mission';
import { LogRow } from './LogRow';
import StickyList from './StickyList';
import { Switch } from '../general/Switch';
import { en } from '../../locales/en';
import { Text } from '../general/Text';

interface Loggable {
  level: LogMessageLevel;
  text: string;
  timestamp?: string | null;
}

interface LogsCardProps {
  title?: string;
  logs: Loggable[];
  height?: string | number;
}

function LogsCard({ title, logs, height = '150px' }: LogsCardProps) {
  const [isErrorsOnly, setIsErrorsOnly] = useState(false);

  const filteredLogs = isErrorsOnly ? logs.filter((log) => log.level === LogMessageLevel.ERROR) : logs;

  const renderLogRow = useCallback(
    (log: Loggable) => <LogRow level={log.level} text={log.text} timestamp={log.timestamp} />,
    []
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Text variant='body2-medium' style={{ textAlign: 'left' }}>
          {title}
        </Text>
        <Switch
          label={en.logsCard.errorsOnly}
          value={isErrorsOnly}
          onChange={setIsErrorsOnly}
          activeColor='var(--color-danger)'
        />
      </div>
      <StickyList
        items={filteredLogs}
        renderRow={renderLogRow}
        style={{
          height: height,
          overflowY: 'auto',
          backgroundColor: 'white',
          borderRadius: 'var(--card-border-radius)',
          border: 'var(--card-border-stroke) var(--card-border-style) var(--card-border-color)',
          padding: '8px'
        }}
      />
    </div>
  );
}

export default LogsCard;
